import { z } from "zod";
import { MetaSchema } from "./shared";

export const userSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),
  isActive: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),
  role: z.string(),
  rank: z.string().nullable(),
  username: z.string().nullable(),
  email: z.string().nullable(),
  avatar: z.string().nullable(),
  activatedPlanAt: z.string().nullable(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
});

export const orderPositionSchema = z.object({
  id: z.string().uuid(),
  baseCurrency: z.string(),
  quoteCurrency: z.string(),
  entryPrice: z.string(),
  liquidationPrice: z.string(),
  closePrice: z.string().nullable(),
  amount: z.string(),
  positionType: z.enum(["long", "short"]),
  positionFee: z.string(),
  type: z.string(),
  status: z.string(),
  pnl: z.number(),
  leverage: z.string(),
  takeProfit: z.string().nullable(),
  stopLoss: z.string().nullable(),
  createdAt: z.string(),
  closedAt: z.string().nullable(),
  user: userSchema,
});


export const getOrdersResponseSchema = z.object({
  data: z.tuple([
    z.array(orderPositionSchema),
    z.number(),
  ]),
  meta: MetaSchema.default,
});

export type GetOrdersResponse = z.infer<typeof getOrdersResponseSchema>;
export type OrderPosition = z.infer<typeof orderPositionSchema>;